module.exports = __webpack_public_path__ + "img/image59.502c7cab.png";